<script>
    /** @type {string} */
    export let action = '';
    /** @type {'get'|'post'} */
    export let method = 'get';
    /** @type {string} */
    export let name = null;
    /** @type {boolean} */
    export let preventDefault = true;

    function handleSubmit(event) {
        if (preventDefault) {
            event.preventDefault();
        }
    }
</script>

<form {name} {action} {method} class="prom-form-container" on:submit={handleSubmit}>
    <slot />
</form>
